<template>
  <v-card class="d-flex pa-4 flex-column" outlined>
    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch" 
      @showType="showType"
      :filters="filterType"
    />
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :expandedItem="true"
      :refreshTable="getData"
      item-key="_id"
    >
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">
          <div class="row sp-details">
            <div class="col-12 mb-4">
              <strong class="label-detail">Request Header</strong>
              <div class="json-text">
              {{ item.request_header }}
              <v-btn
                icon
                small
                class="clipboard-icon"
                @click="copyToClipboard(item.request_header)"
              >
                <v-icon size="18">mdi-clipboard-multiple</v-icon>
              </v-btn>
            </div>
            </div>
            <div class="col-12 mb-4">
              <strong>Request Body</strong>
              <div class="json-text">
              {{ item.request_raw }}
              <v-btn
                icon
                small
                class="clipboard-icon"
                @click="copyToClipboard(item.request_raw)"
              >
                <v-icon size="18">mdi-clipboard-multiple</v-icon>
              </v-btn>
            </div>
            </div>
            <div class="col-12 mb-4">
              <strong>Response Header</strong>
              <div class="json-text">
              {{ item.response_header }}
              <v-btn
                icon
                small
                class="clipboard-icon"
                @click="copyToClipboard(item.response_header)"
              >
                <v-icon size="18">mdi-clipboard-multiple</v-icon>
              </v-btn>
            </div>
            </div>
            <div class="col-12 mb-4">
              <strong>Response Body</strong>
              <div class="json-text">
              {{ item.response_raw }}
              <v-btn
                icon
                small
                class="clipboard-icon"
                @click="copyToClipboard(item.response_raw)"
              >
                <v-icon size="18">mdi-clipboard-multiple</v-icon>
              </v-btn>
            </div>
            </div>
            <div class="col-12 mb-4">
              <strong>Reference</strong>
              <div class="json-text">
              {{ item.reference }}
              <v-btn
                icon
                small
                class="clipboard-icon"
                @click="copyToClipboard(item.reference)"
              >
                <v-icon size="18">mdi-clipboard-multiple</v-icon>
              </v-btn>
            </div>
            </div>
            <div class="col-12 mb-4">
              <strong>Error Description</strong>
              <div class="json-text">
              {{ item.error_description }}
              <v-btn
                icon
                small
                class="clipboard-icon"
                @click="copyToClipboard(item.error_description)"
              >
                <v-icon size="18">mdi-clipboard-multiple</v-icon>
              </v-btn>
            </div>
            </div>
            <div class="col-12 mb-4">
              <strong>Merchant ID</strong>
              <div class="json-text">
              {{ item.merchant_id }}
              <v-btn
                icon
                small
                class="clipboard-icon"
                @click="copyToClipboard(item.merchant_id)"
              >
                <v-icon size="18">mdi-clipboard-multiple</v-icon>
              </v-btn>
            </div>
            </div>
          </div>
        </td>
      </template>


      <template v-slot:custom_status="{ item }">
               <div class="grid-layout">
              <div>
                <strong>Status:</strong> 
                <span :style="{ color: item.status === 'success' ? 'green' : (item.status === 'failed' ? 'red' : 'black') }">
                  {{ item.status }}
                </span>
              </div>
              <div>
                <strong>Reference:</strong> {{ item.reference || ''}}
              </div>
              <div>
                <strong>RRN:</strong> {{ item.response_raw?.QRPaymentCreditRS?.transactionData?.rrn || '' }}
              </div>
              <div>
                <strong>Hostname:</strong> {{ item.hostname }}
              </div>
            </div>
      </template>
    </TableView>
    </v-card>
    
  </template>

<script>
import mobileApiMixin from "@components/system-log/service-log/mobile-api-log/mobileApiMixin.js";

export default {
  mixins: [ mobileApiMixin ],
  components: {
    TableSearchFilter: () => import("@components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
    TableView: () => import("@components/@drontVue/components/Table/TableView.vue"),
  },

};
</script>
<style scoped>
.button-expand {
  padding: 0 !important; 
}
.grid-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px; 
  padding: 5px;
}

.grid-layout div {
  margin-bottom: 10px; 
}
.json-text {
  position: relative;
  background-color: #eeeeee;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.8rem;
  font-weight: bold;
  color: #333333;
  padding: 8px;
  border-radius: 4px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  min-height: 30px;
  word-break: break-all;
}
.clipboard-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1;
  background-color: transparent;
  color: #555;
  transition: color 0.3s;
}

.clipboard-icon:hover {
  color: #000;
}
.sp-details {
  padding: 10px;
  margin: 10px 0 0 15px;
}
</style>